module.exports = __webpack_public_path__ + "static/media/hp_Next.80f431e1.svg";